import { CatalogItem } from "./catalogItem";

export interface Anomaly extends CatalogItem {
    requiresPreoperational: boolean;
    type?: AnomalyType;
}

export enum AnomalyType {
    TRANSPORT_SERVICE = 'transportService',
    ESCORT_SERVICE = 'escortService',
    SATELLITE_LOCK = 'satelliteLock',
}